import { useEffect, useRef } from 'react';
import { getApiErrorMessage, parseApiValidationErrorsWithMessages } from '../../../utils/api.utils';

interface ErrorAlertProps {
  apiError?: unknown;
  exceptionError?: Error;
  errorMessage?: string;
  autoScroll?: boolean;
}

export function ErrorAlert({ apiError, exceptionError, errorMessage, autoScroll = false }: ErrorAlertProps) {
  const alertRef = useRef<HTMLDivElement>(null);
  const message = errorMessage || exceptionError?.message || getApiErrorMessage(apiError);
  const errorsDescription = (parseApiValidationErrorsWithMessages(apiError) ?? []).filter((description) => description !== message);

  useEffect(() => {
    if (autoScroll && (apiError || exceptionError || errorMessage) && alertRef.current) {
      alertRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [apiError, exceptionError, errorMessage, autoScroll]);

  return (
    <div ref={alertRef} className="alert alert-danger mb-3" role="alert">
      <div className="d-flex align-items-start">
        <div>
          <div>{message}</div>
          {errorsDescription.length > 0 && (
            <ul className="mb-0 mt-2">
              {errorsDescription.map((errorMessage, index) => (
                <li key={index}>{errorMessage}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
